//tarayıcı sekmeleri arasında event emit için

export const LibraryQuestionChannel = new BroadcastChannel("library-question-channel");
